import { useEffect } from "react";
import Hero from "./components/Hero";
import TaxFormsDirectory from "./components/TaxFormsDirectory";
import CalculatorsSection from "./components/CalculatorsSection";
import StateResources from "./components/StateResources";
import BlogSection from "./components/BlogSection";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import Navigation from "./components/Navigation";

export default function HomePage() {
  useEffect(() => {
    // Update page title and meta for SEO
    document.title = "ItsJustTax.com - US Tax Forms, Guides & Calculators | Expert Tax Resources";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Navigate US tax season with confidence. Access comprehensive tax forms (1040, Schedule C, 1099), interactive calculators, expert guides, and state tax resources for individuals and small businesses. Free tools and insights for 2025 tax filing.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <Hero />
        <TaxFormsDirectory />
        <CalculatorsSection />
        <StateResources />
        <BlogSection />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}
